/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { useState } from "react";
import { useDocument, useDocumentReadOnly } from "../hook/useDocument";
import { LoaderCircle, Pencil, X } from "lucide-react";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { Button } from "@/components/ui/button";
import { AddressMappingList } from "./address-mapping-list";
import { cn } from "@/lib/utils";

export const DocumentAddressSelect = ({
  data,
  parentKey,
  endPoint,
  keyValue,
}: any) => {
  const [
    state,
    _setState,
    searchAddress,
    updateAddress,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    showBranchId,
  ] = useDocument();
  const [edit, setEdit] = useState(false);
  const [isPending, startTransition] = useState(false);
  // Void and deleted documents are read-only
  const isVoid = useDocumentReadOnly();
  const updateSupplierMappingData = async (prop: any) => {
    console.log({ prop });
    startTransition(true);
    await updateAddress({ key: parentKey, payload: prop });
    startTransition(false);
  };

  return (
    <ConditionRenderer condition={edit}>
      <div className="flex justify-between items-center w-full">
        <AddressMappingList
          placeholder={`Search ${keyValue?.replaceAll("_", " ")}`}
          showBranchId={showBranchId}
          onChange={(prop: string) => {
            setEdit(false);
            updateSupplierMappingData(prop);
            // updateAddress({ key: parentKey, payload: prop });
          }}
          onSearch={(prop) =>
            searchAddress({
              value: prop,
              endPoint: endPoint.value.replace("api", ""),
            })
          }
          value={""}
          onBlur={() => {}}
        />
        <Button
          size={"icon"}
          className="text-red-500"
          variant={"ghost"}
          onClick={() => setEdit(false)}
        >
          <X />
        </Button>
      </div>
      <div
        className={cn(
          "flex justify-between items-center w-full",
          isVoid ? "cursor-default" : "cursor-pointer",
        )}
        onClick={() => !isVoid && setEdit(true)}
      >
        <span className="flex flex-col gap-1">
          {data?.customer_name ? (
            <span>
              <span className="text-[rgb(148,163,184)]">Customer name: </span>
              {data.customer_name}
            </span>
          ) : null}

          {/* <span>
            <span className="text-[rgb(148,163,184)]">Customer id: </span>
            {data.customer_id}
          </span> */}
          {data?.customer_id ? (
            <span className="">
              <span className="text-[rgb(148,163,184)]">Customer id: </span>
              {data.customer_id}
            </span>
          ) : null}
          {data?.branch_name ? (
            <span>
              <span className="text-[rgb(148,163,184)]">Branch name: </span>
              {data.branch_name}
            </span>
          ) : null}
          {showBranchId && data?.branch_id ? (
            <span>
              <span className="text-[rgb(148,163,184)]">Branch id: </span>
              {data.branch_id}
            </span>
          ) : null}

          {data?.billing_address?.erp_id ? (
            <span>
              <span className="text-[rgb(148,163,184)]">Bill to code:</span>
              {data?.billing_address?.erp_id}
            </span>
          ) : null}
          {data?.delivery_address?.erp_id ? (
            <span>
              <span className="text-[rgb(148,163,184)]">Ship to code:</span>
              {data?.delivery_address?.erp_id}
            </span>
          ) : null}

          {data?.address1 ? (
            <span>
              <span className="text-[rgb(148,163,184)]">Address1: </span>
              {data.address1}
            </span>
          ) : null}

          {data?.address2 ? (
            <span>
              <span className="text-[rgb(148,163,184)]">Address2: </span>
              {data.address2}
            </span>
          ) : null}
          {data?.delivery_address?.route ? (
            <span>
              <span className="text-[rgb(148,163,184)]">Route: </span>
              {data.delivery_address.route}
            </span>
          ) : null}

          {Array.isArray(data) ? (
            <span>
              {data
                ?.map((item: any) => item?.text || "")
                .filter((text: string) => text !== "")
                .join(", ")}
            </span>
          ) : null}

          {data?.text && typeof data === "object" && !Array.isArray(data) ? (
            <span>{data.text}</span>
          ) : null}
          {typeof data === "string" || typeof data === "number" ? (
            <span>{data}</span>
          ) : null}
        </span>
        <Button
          size={"icon"}
          className="text-primary"
          variant={"ghost"}
          disabled={isVoid}
          onClick={(e) => {
            e.stopPropagation();
            setEdit(true);
          }}
        >
          <Pencil />
        </Button>
        {isPending ? (
          <span className="absolute left-0 top-0 w-full  h-full bg-white/40 flex items-center justify-center">
            <LoaderCircle className="animate-spin" />
          </span>
        ) : null}
      </div>
    </ConditionRenderer>
  );
};
